import { Mui, MuiIcons } from "@osu/react-ui";
import { Fragment, useRef } from "react";
import { useGetPreferencesQuery } from "../../../../services/graphql/api";
import Form from "./Form.js";

function QuickLinks() {
  useGetPreferencesQuery();
  const autocompleteRef = useRef();

  return (
    <Fragment>
      <Mui.Box className="padding-bottom-2 display-flex align-items-center justify-items-center justify-content-space-between">
        <Mui.Box className="margin-right-1">
          <Mui.Typography variant="h3">Quick Links</Mui.Typography>
          <Mui.Typography className="padding-top-1" variant="body2">
            Add, remove and rearrange the quick links in your dashboard.
          </Mui.Typography>
        </Mui.Box>
        <Mui.Button
          onClick={() => {
            autocompleteRef.current.focus();
          }}
          variant="contained"
          endIcon={<MuiIcons.Add />}
        >
          Add
        </Mui.Button>
      </Mui.Box>
      <Form autocompleteRef={autocompleteRef} />
    </Fragment>
  );
}

export default QuickLinks;
